export const ID_CARD = { aspectRatio: 1.5858 };
export const PASSPORT = { aspectRatio: 1.4205 };
export const A4_PORT = { aspectRatio: 0.7071 };
export const A4_LAND = { aspectRatio: 1.4143 };
